import React from "react";
import ApexCharts from "react-apexcharts";
import {Box, Stack, Tooltip, Typography} from "@mui/material";
import {grey, red} from "@mui/material/colors";
import {CallMissed, PhoneMissed} from "@mui/icons-material";
import {useNavigate} from "react-router-dom";

const RadialSingle = ({ label, count, percent, color }) => {
  const options = {
    chart: {
      type: "radialBar",
      offsetY: 0,
      sparkline: { enabled: true },
    },
    plotOptions: {
      radialBar: {
        startAngle: -90,
        endAngle: 90,
        track: {
          background: "#e7e7e7",
          strokeWidth: "97%",
          margin: 0,
        },
        dataLabels: {
          name: {
            show: true,
            fontSize: "14px",
            color: grey[600],
            offsetY: 60,
            formatter: () => label,
          },
          value: {
            show: true,
            fontSize: "20px",
            color: "#111",
            offsetY: 20,
            formatter: () => "", // Hide the percent inside the chart
          },
        },
      },
    },
    fill: {
      colors: [color],
    },
    labels: [label],
  };

  return (
    <Stack justifyContent="center" alignItems="center" spacing={0}>
      <ApexCharts options={options} series={[percent]} type="radialBar" height={150} width={150} />
      <Typography color={grey[700]} sx={{ mt: 1 }}>
        {count}
      </Typography>
    </Stack>
  );
};

export const ConversationStatusGauge = ({ project, resolved, unresolved, missedCalls }) => {
  const unresolvedExcludingMissed = unresolved - missedCalls;
  const navigate = useNavigate();

  const total = resolved + unresolvedExcludingMissed + missedCalls || 1; // avoid division by zero

  const resolvedPct = (resolved / total) * 100;
  const unresolvedPct = (unresolvedExcludingMissed / total) * 100;
  const missedPct = (missedCalls / total) * 100;

  return (
    <Stack
      direction="column"
      gap={0}
      justifyContent={"space-between"}
      sx={{ borderRadius: 3, flex: 1, p: 0, height: "calc(100% - 0px)" }}
      className={"border-shadow"}
    >
      {/*<Box sx={{ px: 2, pt: 2 }}>*/}
      {/*  <Typography variant={"body1"} color={grey[500]}>*/}
      {/*    CONVERSATION STATUS*/}
      {/*  </Typography>*/}
      {/*</Box>*/}
      <Stack direction="row" spacing={4} justifyContent="center" alignItems="center" sx={{ flex: 1 }}>
        <Tooltip title={"Show Missed Calls"}>
          <Stack onClick={() => navigate(`/project/${project?.id}/supervision?status=${missedCalls ? "MISSED_CALL" : ""}`)} direction={"column"} gap={4} alignItems={"center"} justifyContent={"center"} sx={{height: "calc(100% - 5px)", pt: 4, cursor: "pointer", "&:hover": {transform: "scale(1.05)"}}}>
            <PhoneMissed sx={{fontSize: "50px", color: missedCalls ? red[500] : grey[500] }} className={missedCalls ? "phone-shake" : ""} />
            <Box>
              <Typography align={"center"} fontWeight={600} color={grey[600]} sx={{ mt: 1 }}>
                Missed Calls
              </Typography>
              <Typography align={"center"} color={grey[700]} sx={{ mt: 1 }}>
                {missedCalls}
              </Typography>
            </Box>
          </Stack>
        </Tooltip>
        <RadialSingle label="Resolved" count={resolved} percent={resolvedPct} color="#333333" />
        <RadialSingle label="Unresolved" count={unresolvedExcludingMissed} percent={unresolvedPct} color="#c0c0c0" />
      </Stack>
    </Stack>
  );
};
